export default __webpack_public_path__ + "static/media/trophy.95147c6e.svg";